import type { TreeColumnType } from "../../ColumnSelectionPopover.tsx";

// Returns every configurable column id from a stored template, skipping fixed columns.
export function getTemplateColumnIds(columns: TreeColumnType[] | null | undefined): string[] {
  if (!columns) {
    return [];
  }

  return columns
    .flatMap((column) => {
      if (column.fixed) {
        return [];
      }

      const children = column.children?.filter((child): child is TreeColumnType => child != null) ?? [];

      if (children.length === 0) {
        return column.colId ? [column.colId] : [];
      }

      return children.map((child) => child.colId).filter((colId): colId is string => colId != null);
    })
    .filter((colId): colId is string => colId != null);
}
